// extracted by mini-css-extract-plugin
export var active = "_1y-7";
export var backButton = "_1y-6";
export var collapseBar = "_1y-f";
export var collapseMode = "_1y-h";
export var dragHandle = "_1y-a";
export var dropdownIcon = "_1y-d";
export var hidden = "_1y-n";
export var iconContainer = "_1y-k";
export var iconSwapper = "_1y-m";
export var navItem = "_1y-4";
export var navItemIcon = "_1y-c";
export var navProfile = "_1y-5";
export var notificationDot = "_1y-l";
export var optionsContainer = "_1y-e";
export var primaryNav = "_1y-0";
export var primaryTab = "_1y-i";
export var secondaryNav = "_1y-1";
export var selected = "_1y-j";
export var settingsNav = "_1y-2";
export var settingsNavItems = "_1y-3";
export var show = "_1y-b";
export var sideNav = "_1y-g";
export var teamItem = "_1y-8";
export var userProfileItem = "_1y-9";